// extracted by mini-css-extract-plugin
export default {"container":"Select_container__z0Md-","block":"Select_block__zq40s","select":"Select_select__lV6l4","invalid":"Select_invalid__OBleZ","label":"Select_label__iNkK+"};